module.exports = __webpack_public_path__ + "img/yamaguchi.7782dc77.png";